export default "__VITE_ASSET__18ios968__"